// src/pages/About.js
import React from 'react';
import '../styles/SuitcaseTheatreArcadeStyle.css';
import SuitcaseLogo from '../static/images/SuitcaseTheatreArcadeLogo.jpg';


function About() {
    return (
        <div className="outer-about-container">
            <div className="page-headline" id="about-title">
                <h1>About Suitcase Theatre Arcade</h1>
            </div>
            <div className="about-container fade-in">
                <div className="image-container">
                    <img id="suitcase-theatre-arcade-image" src= {SuitcaseLogo} alt={"Suitcase Theatre Arcade"}/>
                </div>
                <div className="text-container">
                    <p>
                        Put on headphones and zone in on miniature puppet worlds.

                        We develop, build and share miniature puppet shows that are built and presented from all kinds of different cases, from suitcases to computer cases.

                        Originally, in 2011, the first two mini-puppet shows were commissioned and built by Calgary Animated Objects Society, during a summer internship program. Ever since, more puppet shows were built and presented at various events, including The International Festival of Animated Objects.

                        The Suitcase Theatre Arcade promotes STEAM concepts through the development of miniature puppet shows made from a wide variety of materials, re-used included.
                    </p>
                        <ul>
                            <li>Major gratitude for the current and past puppeteers, collaborators and creators:</li>
                            <li>Kyle Hinton</li>
                            <li>Sara McNeil</li>
                            <li>Darya Ivanova</li>
                            <li>Jocelyn Mah</li>
                            <li>Elaine Weryshko</li>
                            <li>Claudia Chagoya</li>
                            <li>Tia DeLauria</li>
                            <li>Kai Hall</li>
                            <li>Jay Northcott</li>
                            <li>Jennifer LeBlanc</li>
                            <li>Ali Deregt</li>
                            <li>Celene Elizabeth</li>
                            <li>Berkeley Pickell</li>
                            <li>Jilian Long</li>
                            <li>Janessa Johnsrude</li>
                        </ul>
                        <p>
                            Major, major gratitude to Market Collective, The Festival of Animated Objects, Calgary Animated Objects Society, DRiP Haus, and to anyone who has supported our shows!
                        </p>
                </div>
            </div>
        </div>
    );
}

export default About;